export default __webpack_public_path__ + "static/media/Ellipse.fc74bb31.png";